const buildSubclanSubmenu = (t, subclanCategories = []) => {
  const namedCategories = (subclanCategories || [])
    .map((category) => `${category?.name || ""}`.trim())
    .filter(Boolean);

  const submenu = [
    {
      key: "my-subclans",
      label: t("topbar_my_subclans", "My Subclans"),
      link: "/subclans/my",
    },
    {
      key: "all-subclans",
      label: t("topbar_all_subclans", "All Subclans"),
      link: "/subclans/all",
    },
    {
      key: "add-subclan",
      label: t("topbar_add_subclan", "+ Add Subclan"),
      link: "/subclans/all",
      icon: "fa fa-plus",
      accent: true,
    },
  ];

  if (namedCategories.length) {
    submenu.push({ key: "divider-1", type: "divider" });
    submenu.push({
      key: "subclan-category-heading",
      type: "section",
      label: t("topbar_subclan_categories", "Subclan Categories"),
    });

    namedCategories.forEach((categoryName) => {
      submenu.push({
        key: `subclan-category-${categoryName}`,
        label: categoryName,
        link: `/subclans/all?category=${encodeURIComponent(categoryName)}`,
      });
    });
  }

  return submenu;
};

export function buildTopbarMenuModel(
  t,
  { enableInvites = true, forumEnabled = true, subclanCategories = [] } = {}
) {
  const primaryItems = [
    {
      key: "home",
      link: "/home",
      label: t("topbar_news_feed", "Workspace Feed"),
      icon: "home",
    },
    {
      key: "friends",
      link: "/friends",
      label: t("topbar_friends", "Connections"),
      icon: "people",
      dynamicTo: true,
    },
    {
      key: "notifications",
      link: "/notifications/all",
      label: t("topbar_notifications", "Notifications"),
      icon: "bell",
    },
    {
      key: "messages",
      link: "/messages/all",
      label: t("topbar_messages", "Messages"),
      icon: "envelope",
    },
  ];

  if (enableInvites) {
    primaryItems.push({
      key: "invite",
      action: "open_invite_dialog",
      label: t("topbar_invite_friends", "Invite People"),
      icon: "personAdd",
    });
  }

  primaryItems.push(
    {
      key: "events",
      link: "/event/all",
      label: t("topbar_events", "Events"),
      icon: "calendar",
    },
    {
      key: "members",
      link: "/members",
      label: t("topbar_site_members", "Members"),
      icon: "members",
    },
    {
      key: "subclans",
      link: "/subclans/all",
      label: t("topbar_subclans", "Subclans"),
      icon: "subclan",
      submenu: buildSubclanSubmenu(t, subclanCategories),
      promoteRight: true,
      alignRight: true,
    }
  );

  if (forumEnabled) {
    primaryItems.push({
      key: "forum",
      link: "/forum",
      label: t("topbar_forum", "Forum"),
      icon: "forum",
    });
  }

  const moreItems = [
    {
      key: "events",
      label: t("topbar_events", "Events"),
      icon: "fa fa-calendar",
      submenu: [
        { key: "all-events", label: t("topbar_all_events", "All Events"), link: "/event/list" },
        { key: "calendar", label: t("topbar_calendar", "Calendar"), link: "/event/calendar" },
        { key: "my-events", label: t("topbar_my_events", "My Events"), link: "/event/my" },
        {
          key: "add-event",
          label: t("topbar_add_event", "+ Add Event"),
          link: "/event/add",
          icon: "fa fa-plus",
        },
      ],
    },
    {
      key: "mp3",
      label: "MP3",
      icon: "fa fa-headphones",
      submenu: [
        { key: "my-audios", label: "My Audios", link: "/mp3/my" },
        { key: "all-audios", label: "All Audios", link: "/mp3/all" },
        { key: "add-audio", label: "+ Add Audio", link: "/mp3/add", icon: "fa fa-plus" },
      ],
    },
    {
      key: "files",
      label: "Files",
      icon: "fa fa-file",
      submenu: [
        { key: "my-files", label: "My Files", link: "/files/my" },
        { key: "all-files", label: "All Files", link: "/files/all" },
        { key: "add-file", label: "+ Add File", link: "/files/add", icon: "fa fa-plus" },
      ],
    },
    {
      key: "subclan-chat",
      label: "Subclan Chat",
      icon: "fa fa-commenting",
      submenu: [
        { key: "rooms", label: "Rooms", link: "/subclan_messages/list" },
        { key: "rooms-member", label: "Rooms I'm a Member", link: "/subclan_messages/member" },
        { key: "add-room", label: "+ Add Room", link: "/subclan_messages/create", icon: "fa fa-plus" },
      ],
    },
    {
      key: "user-categories",
      label: "User Categories",
      icon: "fa fa-tags",
      submenu: [
        { key: "staff", label: "Staff", link: "/users/1456/staff" },
        { key: "candidates", label: "Candidates", link: "/users/1457/candidates" },
        { key: "alumni", label: "Alumni", link: "/users/1458/alumni" },
        { key: "mentor", label: "Mentor", link: "/users/1459/mentor" },
        { key: "champion", label: "Champion", link: "/users/1460/champion" },
      ],
    },
    {
      key: "videos",
      label: "Videos",
      icon: "fa fa-video-camera",
      submenu: [
        { key: "all-videos", label: "All site videos", link: "/video/list/all" },
        { key: "my-videos", label: "My videos", link: "/videos/my" },
        { key: "add-video", label: "+ Add video", link: "/video/add", icon: "fa fa-plus" },
      ],
    },
    {
      key: "polls",
      label: "Polls",
      icon: "fa fa-bar-chart",
      submenu: [
        { key: "my-polls", label: "My Polls", link: "/polls/my" },
        { key: "all-polls", label: "All Polls", link: "/polls/list/all" },
      ],
    },
    {
      key: "site-members",
      label: "Site Members",
      icon: "fa fa-user",
      submenu: [
        { key: "male", label: "Male", link: "/site_members/male" },
        { key: "female", label: "Female", link: "/site_members/female" },
      ],
    },
  ];

  return { primaryItems, moreItems };
}
